import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import DropDownList from "../../../../../ReusableComponents/DropDownList/DropDownList";

export default function UpdateInsDetailsPopup({
  listData,
  token,
  PopUp,
  setPopUp,
  title,
  callBack,
}) {
  console.log(listData);
  const [schemaList, setSchemaList] = useState([]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    empId: listData.emp_id,
    pointOfHire: listData.point_of_hire,
    relation: "Employee",
    insCompany: "",
    policyNumber: "",
    class: "",
    insApplyDate: "",
    insIssueDate: "",
    memberShipNumber: listData.membership_no,
    insOn: "",
    insStatus: "Active",
    MarialStatus: "",
  });

  console.log("formData to be seen in console", formData);
  const [showError, setShowError] = useState(false);
  const [errorMessege, setErrorMessege] = useState([]);
  const submitHandler = async (e) => {
    e.preventDefault();
    const getData = schemaList?.filter((data) => data.class === formData.class);

    const emptyFields = Object.entries(formData).filter(
      ([key, value]) => value === ""
    );

    if (emptyFields.length > 0) {
      // Generate a list of fields that are empty for error message
      const fieldNames = emptyFields.map(([key]) => key).join(", ");
      console.error(`The following fields are empty: ${fieldNames}`);
      dispatch(
        setAppError({
          msg: `The following fields are required: ${fieldNames}`,
        })
      );
      return; // Stop submission
    }
    try {
      const res = await nodeinstance.post(
        "employee-insurance/update-insurance",
        {
          employeeId: formData.empId,
          InsuranceApplyDate: formData.insApplyDate,
          InsuranceIssueDate: formData.insIssueDate,
          InsuranceCompany: formData.insCompany,
          MembershipId: formData.memberShipNumber,
          InsuredOn: formData.insOn,
          insuranceSchemeId: getData && getData[0].insurance_scheme_id,
          Relation: formData.relation,
          Class: formData.class,
          marital_status: formData.MarialStatus,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("res", res);
      if (res.status == 200) {
        if (res.data?.data?.errors?.length > 0) {
          setShowError(true);
          setErrorMessege(res.data.data.errors);
        } else {
          dispatch(
            setAppError({
              msg: res?.data?.message,
              color: "success",
            })
          );

          setPopUp(false);
          callBack();
        }
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };

  const [dropDoenList, SetDropDownList] = React.useState([]);

  const getCompanyName = async () => {
    try {
      const result = await nodeinstance.get("employee-insurance/impCompany", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = result?.data?.data;
      console.log("data", data);
      SetDropDownList(data);
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  const getSchemeName = async (id) => {
    console.log(id);
    try {
      const result = await nodeinstance.get(
        `employee-insurance/impClass?keyword=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = result?.data?.data;
      console.log(".....data to be printed in console", data);
      setSchemaList(data);
    } catch (error) {
      dispatch(setAppError({ msg: `${error?.message}` }));
    }
  };

  useEffect(() => {
    getCompanyName();
  }, []);
  console.log("browser page to be seen in the console", errorMessege);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold">
              Local EMPLOYEE Insurance Details
            </h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp();
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {showError ? (
            errorMessege?.map((data, index) => <h1 key={index} className = "mt-3">* {data.error}</h1>)
          ) : (
            <form
              onSubmit={(e) => submitHandler(e)}
              className="w-full place-items-center"
            >
              <div className="w-full place-items-center">
                <div className="w-full flex flex-col gap-3 my-3 p-2">
                  <div className="form-control w-full scroll-m-0">
                    <h2 className="label place-items-center">
                      <span className="label-text">Point of Hire</span>
                    </h2>

                    <input
                      disabled={true}
                      defaultValue={formData.pointOfHire}
                      id="field2"
                      className={`input input-xl h-10 input-bordered focus:outline-none uppercase`}
                      required
                      onChange={(e) => setAddmissionData(e.target.value)}
                    />

                    {/* emp_id */}
                    <h2 className="label place-items-center">
                      <span className="label-text">EMPLOYEE ID</span>
                    </h2>
                    <input
                      disabled={true}
                      defaultValue={formData.empId}
                      id="field2"
                      className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                      required
                      onChange={(e) => setAddmissionData(e.target.value)}
                    />
                    {/* Relation */}
                    <h2 className="label place-items-center">
                      <span className="label-text">Relation</span>
                    </h2>
                    <input
                      disabled={true}
                      defaultValue={formData.relation}
                      id="field2"
                      className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                      required
                      onChange={(e) => setAddmissionData(e.target.value)}
                    />
                    {/* Relation */}

                    <h2 className="label place-items-center">
                      <span className="label-text">Insurance Company</span>
                    </h2>

                    <div className="w-full">
                      <div className="w-full">
                        <select
                          className="select select-sm select-bordered uppercase h-10 w-full"
                          onChange={(event) => {
                            const selectedId = event.target.value; // Get the selected value
                            const selectedOption = dropDoenList?.find(
                              (option) => option.Insurance_name === selectedId
                            );
                            const policyNumber =
                              selectedOption?.PolicyNumber[0]?.policy_no;
                            setFormData({
                              ...formData,
                              insCompany: selectedId,
                              policyNumber: policyNumber,
                              class: "",
                            });
                            getSchemeName(selectedOption.Insurance_id);
                          }}
                        >
                          <option value="">Insurance Company</option>
                          {dropDoenList?.map((filetype) => (
                            <option
                              key={filetype?.Insurance_id}
                              value={filetype?.Insurance_name}
                            >
                              {filetype?.Insurance_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Relation */}
                    <h2 className="label place-items-center">
                      <span className="label-text">Policy Number</span>
                    </h2>
                    <input
                      disabled={true}
                      defaultValue={formData.policyNumber}
                      id="field2"
                      className={`input input-xl h-10 input-bordered focus:outline-none uppercase`}
                      required
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          policyNumber: e.target.value,
                        })
                      }
                    />
                    <h2 className="label place-items-center">
                      <span className="label-text">Class</span>
                    </h2>
                    <div className="w-full">
                      <div className="w-full">
                        <select
                          className="select select-sm select-bordered uppercase h-10 w-full"
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              class: e.target.value,
                            })
                          }
                        >
                          <option value="">Class</option>
                          {schemaList.map((filetype) => (
                            <option key={filetype?.id} value={filetype?.class}>
                              {filetype?.class}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <h2 className="label place-items-center">
                      <span className="label-text">Insurance Apply Date</span>
                    </h2>

                    <div className="w-full">
                      <input
                        type="date"
                        onKeyDown={handleKeyDown}
                        id="field2"
                        className={`input input-xl h-10 w-full input-bordered focus:outline-none uppercase`}
                        required
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            insApplyDate: e.target.value,
                          })
                        }
                      />
                    </div>
                    <h2 className="label place-items-center">
                      <span className="label-text">Insurance Issue Date</span>
                    </h2>
                    <div className="w-full">
                      <input
                        type="date"
                        onKeyDown={handleKeyDown}
                        id="field2"
                        className={`input input-xl h-10 w-full input-bordered focus:outline-none uppercase`}
                        required
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            insIssueDate: e.target.value,
                          })
                        }
                      />
                    </div>

                    <h2 className="label place-items-center">
                      <span className="label-text">Membership Number</span>
                    </h2>
                    <div className="w-full">
                      <input
                        defaultValue={formData.memberShipNumber}
                        type="number"
                        className={`input input-xl h-10  input-bordered focus:outline-none uppercase w-full`}
                        required
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            memberShipNumber: e.target.value,
                          })
                        }
                      />
                    </div>
                    <h2 className="label place-items-center">
                      <span className="label-text">Insurance On</span>
                    </h2>

                    <DropDownList
                      value={formData.insOn}
                      setValue={(e) => {
                        setFormData({
                          ...formData,
                          insOn: e.target.value,
                        });
                      }}
                      presetValues={[
                        { value: "BORDER NUMBER" },
                        { value: "IQAMA NUMBER" },
                      ]}
                    />
                    <h2 className="label place-items-center">
                      <span className="label-text">Marial status</span>
                    </h2>

                    <DropDownList
                      value={formData.MarialStatus}
                      setValue={(e) => {
                        setFormData({
                          ...formData,
                          MarialStatus: e.target.value,
                        });
                      }}
                      presetValues={[{ value: "MARRIED" }, { value: "SINGLE" }]}
                    />
                    <h2 className="label place-items-center">
                      <span className="label-text">Insurance status</span>
                    </h2>

                    <input
                      disabled={true}
                      defaultValue={formData.insStatus}
                      id="field2"
                      className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
                      required
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          insStatus: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div
                    className="flex gap-3 w-full justify-center"
                    style={{ margin: 2 }}
                  >
                    <button
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                    >
                      <p>Submit</p>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
